export interface ISeasonStandingMetadata {
  cashDescription: string;
  cashName: string;
  pointsDescription: string;
  pointsName: string;
  scripDescription: string;
  scripName: string;
}

export interface ISeason extends ISeasonStandingMetadata {
  club: number;
  end: string;
  id: number;
  start: string;
  year: string;
}

export interface ISeasonsStore {
  [clubId: string]: {
    seasons: ISeason[];
    currentSeason: ISeason;
  };
}
export const seasonsStore = {};
